import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './assets/Icon--Ubiant.png'
import _imports_1 from './assets/Logo--Ubiant.png'


const _withScopeId = n => (_pushScopeId("data-v-e9f42e02"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-column" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "app-label-small text-gray-d1 font-bold p-2" }, "Langues", -1))
const _hoisted_3 = { class: "flex flex-wrap justify-content-between" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "app-label-small text-gray-d1 font-medium" }
const _hoisted_6 = { class: "flex flex-column" }
const _hoisted_7 = { class: "promote mt-4 grid grid-nogutter" }
const _hoisted_8 = { class: "col-7" }
const _hoisted_9 = { class: "app-label-small font-bold text-white" }
const _hoisted_10 = { class: "col-7" }
const _hoisted_11 = { class: "app-label-micro font-bold text-gray-l3" }
const _hoisted_12 = { class: "flex justify-content-center mt-3 mb-2" }
const _hoisted_13 = { class: "flex flex-column h-full" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ci-icon-applications text-white",
  style: {"font-size":"25px"}
}, null, -1))
const _hoisted_15 = {
  key: 0,
  class: "ml-2 app-label-small"
}
const _hoisted_16 = { class: "flex ml-1" }
const _hoisted_17 = { class: "flex flex-column justify-content-between mt-2" }
const _hoisted_18 = { class: "flex align-items-center justify-content-center m-2" }
const _hoisted_19 = {
  key: 0,
  class: "ci-icon-account text-default-black"
}
const _hoisted_20 = {
  key: 1,
  class: "ci-arrows-full-down -rotate-90 text-default-black"
}
const _hoisted_21 = { class: "flex align-items-center justify-content-center" }
const _hoisted_22 = { class: "-rotate-180 w-mode-v-lr app-label-small font-bold text-default-black" }
const _hoisted_23 = {
  key: 1,
  class: "flex flex-column h-full overflow-auto"
}
const _hoisted_24 = { class: "sticky top-0 bg-gray-l3" }
const _hoisted_25 = { class: "flex" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ci-icon-account text-default-black" }, null, -1))
const _hoisted_27 = { class: "app-label font-bold ml-2 text-default-black" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ci-arrows-full-down rotate-90 text-default-black" }, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line-section-white" }, null, -1))
const _hoisted_30 = { class: "flex align-items-center justify-content-start m-2" }
const _hoisted_31 = { class: "app-label-small font-bold text-gray-l1" }
const _hoisted_32 = { class: "user-card mb-3 mr-2 ml-2 cursor-pointer" }
const _hoisted_33 = { class: "initial m-1 flex align-items-center justify-content-center" }
const _hoisted_34 = { class: "p-1 app-label-small text-white font-normal uppercase" }
const _hoisted_35 = { class: "ml-2 flex flex-column align-items-center justify-content-center" }
const _hoisted_36 = { class: "flex col-12 p-0" }
const _hoisted_37 = { class: "app-label-small font-normal" }
const _hoisted_38 = { class: "flex col-12 p-0" }
const _hoisted_39 = { class: "vertical-align-top app-label-micro text-gray-l1 font-normal" }
const _hoisted_40 = { class: "flex flex-column mt-auto justify-content-center" }
const _hoisted_41 = {
  key: 0,
  class: "mobile-log"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line-section-gray" }, null, -1))
const _hoisted_43 = { class: "flex justify-content-center" }
const _hoisted_44 = { class: "app-label-small text-gray-l1 font-bold" }
const _hoisted_45 = { key: 1 }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line-section-gray" }, null, -1))
const _hoisted_47 = { class: "flex align-items-center justify-content-start m-2" }
const _hoisted_48 = { class: "app-label-small font-bold text-gray-l1" }
const _hoisted_49 = { class: "p-1" }
const _hoisted_50 = { class: "menu-link" }
const _hoisted_51 = { class: "flex w-full align-items-center justify-content-between" }
const _hoisted_52 = { class: "flex justify-content-start align-items-center" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mr-2 ci-icon-layers" }, null, -1))
const _hoisted_54 = { class: "app-label-small text-gray-d1 font-medium" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex link-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ci-arrows-right" })
], -1))
const _hoisted_56 = { class: "flex justify-content-center mt-3 mb-3" }
const _hoisted_57 = {
  key: 0,
  src: _imports_0,
  alt: "icon-ubiant"
}
const _hoisted_58 = {
  key: 1,
  src: _imports_1,
  alt: "logo-ubiant"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_AppSubMenuLink = _resolveComponent("AppSubMenuLink")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AppMenuLink = _resolveComponent("AppMenuLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_OverlayPanel, {
      ref: "languageMenu",
      style: { width: '190px' }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$i18n.availableLocales, (l) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "col-12 lg:col-6 l-option",
                key: l,
                onClick: ($event: any) => (_ctx.selectLanguage($event, l))
              }, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('languages.' + l)), 1)
              ], 8, _hoisted_4))
            }), 128))
          ])
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_OverlayPanel, {
      ref: "op",
      style: { width: '190px' }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_AppSubMenuLink, { items: _ctx.appListItem }, null, 8, ["items"]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('demo.create-twin')), 1)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('demo.description')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_app_button, {
              buttonType: "text",
              buttonSize: "xs",
              buttonText: _ctx.$t('button-label.app-store'),
              isDisabled: false
            }, null, 8, ["buttonText"])
          ])
        ])
      ]),
      _: 1
    }, 512),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", {
        class: _normalizeClass(["flex mosaic-tab text-white align-items-center cursor-pointer", _ctx.menuActive ? 'justify-content-start p-2' : 'justify-content-center']),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onAppsButtonClick($event)))
      }, [
        _hoisted_14,
        (_ctx.menuActive)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.$t('commons.apps')), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_16, [
          (_ctx.menuActive)
            ? (_openBlock(), _createElementBlock("i", {
                key: 0,
                class: _normalizeClass(['ci-arrows-down text-white text-xs', _ctx.appsMenuActive ? 'rotate-180' : ''])
              }, null, 2))
            : _createCommentVNode("", true)
        ])
      ], 2),
      (!_ctx.menuActive)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "flex flex-column justify-content-between cursor-pointer",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onMenuButtonClick($event)))
          }, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                (!_ctx.hoverMenuActive)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_19))
                  : (_openBlock(), _createElementBlock("i", _hoisted_20))
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.$t('app-name')), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.menuActive)
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", {
                class: "flex w-full align-items-center justify-content-between p-2 cursor-pointer mt-2",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onMenuButtonClick($event)))
              }, [
                _createElementVNode("div", _hoisted_25, [
                  _hoisted_26,
                  _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t('app-name')), 1)
                ]),
                _hoisted_28
              ]),
              _hoisted_29
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t('menu-label.account-title')), 1)
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createVNode(_component_router_link, {
                to: "/home",
                class: "flex"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.userInitial), 1)
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.userFullName), 1)
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.userLicense), 1)
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_AppMenuLink, { menuItems: _ctx.subscriptionMenuItems }, null, 8, ["menuItems"]),
            _createVNode(_component_AppMenuLink, { menuItems: _ctx.buildingMenuItems }, null, 8, ["menuItems"]),
            _createVNode(_component_AppMenuLink, { menuItems: _ctx.rightsMenuItems }, null, 8, ["menuItems"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_40, [
        (_ctx.menuActive)
          ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
              _hoisted_42,
              _createElementVNode("div", {
                class: "cursor-pointer",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.log && _ctx.log(...args)))
              }, [
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.logText()), 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.menuActive)
          ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
              _hoisted_46,
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.$t('menu-section.general')), 1)
              ]),
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("a", {
                    class: "flex align-items-center p-1 menu-h-30",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onLanguageMenuClick($event)))
                  }, [
                    _createElementVNode("div", _hoisted_51, [
                      _createElementVNode("div", _hoisted_52, [
                        _hoisted_53,
                        _createElementVNode("div", null, [
                          _createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.$t('languages.' + _ctx.$i18n.locale)), 1)
                        ])
                      ]),
                      _hoisted_55
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_56, [
          (!_ctx.menuActive)
            ? (_openBlock(), _createElementBlock("img", _hoisted_57))
            : _createCommentVNode("", true),
          (_ctx.menuActive)
            ? (_openBlock(), _createElementBlock("img", _hoisted_58))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 64))
}